import React from "react";
import { Link } from "react-router-dom";
import { Home, Flame } from "lucide-react";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <div className="max-w-xl mx-auto px-6 py-28 text-center">
      <Seo title="Page Not Found" description="The page you are looking for could not be found." path="/404" />
      <Flame className="h-14 w-14 text-tara-gold mx-auto mb-6 flame-flicker" />
      <h1 className="font-serif text-6xl font-bold gold-text mb-3">404</h1>
      <p className="text-tara-muted mb-8">This path does not exist. Return to the sacred hearth.</p>
      <Link to="/" className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-tara-gold to-tara-vermilion px-6 py-3 font-serif font-semibold text-white hover:brightness-110 transition" data-testid="notfound-home-btn">
        <Home className="h-5 w-5" /> Back Home
      </Link>
    </div>
  );
}
